var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlyph082Locker = function SvgGlyph082Locker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 337 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 88v337h337V88Zm320 141h-89.67V105H320Zm-196.33-30h89.66v77h-89.66Zm89.66-17h-89.66v-77h89.66ZM106.67 370H17V246h89.67Zm17-77h89.66v77h-89.66Zm106.66-47H320v124h-89.67ZM106.67 105v124H17V105ZM17 408v-21h303v21Zm183.65-196.52v52h-62v-52Z"
  })));
};
export default SvgGlyph082Locker;